import i18next from 'i18next';
import { NumberOfCalls } from 'infrastructure/enums';

export interface INumberOfCallsItem {
  id: NumberOfCalls | null;
  name: string;
}

export const numberOfCallsDataSource = (
  withNone = true,
): INumberOfCallsItem[] => {
  const dataSource: INumberOfCallsItem[] = [
    {
      id: NumberOfCalls.Zero,
      name: i18next.t('labels.zeroCalls'),
    },
    {
      id: NumberOfCalls.One,
      name: i18next.t('labels.oneCall'),
    },
  ];

  if (withNone) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
